import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const links = [
  { label: "Home", href: "https://www.revolstudios.co", active: false, testid: "nav-link-home" },
  { label: "FAQs", href: "/", active: true, testid: "nav-link-revel-engine" },
  { label: "ROI Calculator", href: "https://roi.revolstudios.io", active: false, testid: "nav-link-roi-calculator" },
  { label: "Estimate", href: "https://estimate.revolstudios.io", active: false, testid: "nav-link-estimate" },
];

export const Navbar = ({ onBookCall }) => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 left-0 right-0 z-50 h-20 border-b border-white/10 backdrop-blur-xl"
    style={{ background: "linear-gradient(180deg, #111133 0%, rgba(0,0,0,0.95) 100%)" }}
    data-testid="nav-header"
  >
    <div className="max-w-7xl mx-auto h-full px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-4">
      <a href="/" className="flex items-center gap-3 shrink-0" data-testid="nav-logo-link">
        <img
          src="/revol-logo.png"
          alt="Revol Studios"
          className="h-10 w-40 object-cover object-center rounded-md border border-white/10"
          data-testid="nav-logo"
        />
      </a>

      <nav className="hidden md:flex items-center gap-8" data-testid="nav-links">
        {links.map((l) => (
          <a
            key={l.label}
            href={l.href}
            data-testid={l.testid}
            className={`relative text-sm font-medium transition-colors duration-200 ${
              l.active ? "text-white" : "text-[#a1a1aa] hover:text-white"
            }`}
          >
            {l.label}
            {l.active && (
              <motion.span
                layoutId="nav-active"
                className="absolute -bottom-2 left-1/2 -translate-x-1/2 h-1 w-1 rounded-full bg-[#ed4609] shadow-[0_0_8px_#ed4609]"
              />
            )}
          </a>
        ))}
      </nav>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.97 }}
        onClick={onBookCall}
        data-testid="nav-book-call-button"
        className="flex items-center gap-1.5 rounded-full bg-[#ed4609] px-4 sm:px-5 py-2.5 text-xs sm:text-sm font-semibold text-white transition-shadow duration-200 hover:bg-[#ff571a] hover:shadow-[0_0_24px_rgba(237,70,9,0.45)]"
      >
        Book a Strategy Call
        <ArrowUpRight className="h-4 w-4" />
      </motion.button>
    </div>
  </motion.header>
);
